import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState:any = {}

const giftCardsPricing = createSlice({
  name: 'giftCardsPricing',
  initialState,
  reducers: {
    setGiftCardsPricing(state,action:PayloadAction<any>){
        return (state = action.payload)
    }
  },

});

// Reducer
export default giftCardsPricing.reducer;

// Actions
export const {setGiftCardsPricing} = giftCardsPricing.actions;

